import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Role, UserList } from 'app/models/user.model';
import { AdministracionService } from 'app/services/administracion.service';
import { ExcelService } from 'app/services/excel.service';
import { take } from 'rxjs';
import { ExcelApi } from 'app/models/excel.model';
import { saveAs } from 'file-saver';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'usuarios',
    templateUrl: './usuarios.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./usuarios.component.scss'],
    animations: fuseAnimations,
})
export class UsuariosComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlertCrear: boolean = false;
    showAlertEditar: boolean = false;

    roles: Role[];
    search: string = '';
    currentSearch: string = '';
    cargandoDatos: boolean = false;
    eliminandoDatos: boolean = false;

    public customPatterns = { '0': { pattern: new RegExp('^[a-zA-ZñÑáéíóúÁÉÍÓÚ .-@_]{1,30}$') } };

    displayedColumns: string[] = ['select', 'RUTDV', 'CORREO', 'NOMBRE', 'ROL', 'editar'];

    dataSource: MatTableDataSource<UserList>;
    selection = new SelectionModel<UserList>(true, []);

    loadingExcel: boolean = false;
    guardandoUser: boolean = false;

    userModel: {
        userId: string;
        email: string;
        nombre: string;
        rutDv: string;
        rolId: string;
    } = null;

    constructor(private route: Router, private _administracion: AdministracionService, private _excel: ExcelService) {}

    ngOnInit() {
        /* Configuracion basica */
        this._administracion
            .listarRoles()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.roles = data;
                },
                error: (err: any) => {
                    //console.log(err);
                },
                complete: () => {
                    let optDefault: Role = {
                        id: '',
                        name: 'Seleccione',
                        description: '',
                    };
                    this.roles.unshift(optDefault);
                },
            });
        this.listarUsuarios();
    }

    buscarUsuarios() {
        this.currentSearch = this.search;
        this.listarUsuarios();
    }

    listarUsuarios() {
        this.cargandoDatos = true;
        this._administracion
            .listarUsuarios(this.currentSearch)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.dataSource = new MatTableDataSource<UserList>(data);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.selection = new SelectionModel<UserList>(true, []);
                    this.cargandoDatos = false;
                },
                error: (err: any) => {
                    //console.log(err);
                    this.cargandoDatos = false;
                },
                complete: () => {},
            });
    }

    goback(): void {
        this.route.navigateByUrl('home/admin');
    }

    modalCrear: boolean = false;
    modalEditar: boolean = false;
    modalBaja: boolean = false;

    /**
        Función para eliminar del dataSource los elementos seleccionados.
    */
    borrarSeleccionados() {
        let userIds = this.selection.selected.map((m) => m.IDENTIFICADOR);

        if (userIds.length == 0) {
            return;
        }

        this.eliminandoDatos = true;
        this._administracion
            .eliminaUsuarios(userIds)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.listarUsuarios();
                    this.eliminandoDatos = false;
                    this.modalBaja = false;
                },
                error: (err: any) => {
                    this.listarUsuarios();
                    this.eliminandoDatos = false;
                    this.modalBaja = false;
                },
                complete: () => {},
            });
        // // this.dataSource.data = this.dataSource.data.filter((f) => !this.selection.selected.some((s) => s.id == f.id))
        // // this.selection = new SelectionModel<any>(true, [])
        // // this.dataSource._updateChangeSubscription()
        // console.log('dataSourceeliminado', this.dataSource.data)
    }

    /* Funciones de selección */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    // /* Carga correcta del sort */
    // ngAfterViewInit() {
    //     this.dataSource.sort = this.sort
    // }

    hasItem(usuario: UserList) {
        return this.selection.selected.some(({ IDENTIFICADOR }) => {
            return IDENTIFICADOR === usuario.IDENTIFICADOR;
        });
    }

    handleClick(usuario: UserList): void {
        let payload: UserList[] = [];

        const checked = this.selection.selected.some(({ IDENTIFICADOR }) => {
            return IDENTIFICADOR === usuario.IDENTIFICADOR;
        });

        if (!checked) {
            payload = [...this.selection.selected, usuario];
        } else {
            payload = this.selection.selected.filter(({ IDENTIFICADOR }) => IDENTIFICADOR !== usuario.IDENTIFICADOR);
        }

        this.selection = new SelectionModel<any>(true, [...payload]);
    }

    descargarExcel() {
        let excel: ExcelApi = {
            config: {
                workSheetName: 'Usuarios',
                columns: [
                    { tittle: 'RUT', type: 'string', dataKey: 'RUTDV', width: 20 },
                    { tittle: 'USUARIO(EMAIL)', type: 'string', dataKey: 'CORREO', width: 20 },
                    { tittle: 'NOMBRE DE USUARIO', type: 'string', dataKey: 'NOMBRE', width: 20 },
                    { tittle: 'ROL', type: 'string', dataKey: 'ROL', width: 20 },
                ],
            },
            arrData: this.dataSource.data,
        };

        if (excel.arrData.length > 0) {
            this.loadingExcel = true;
            this._excel.generarExcel(excel).subscribe({
                next: (resp) => {
                    saveAs(resp.body, 'Usuarios');
                    this.loadingExcel = false;
                },
                error: (err) => {
                    //console.log('Err Excel');
                    //console.log(err);
                    this.loadingExcel = false;
                },
                complete: () => {},
            });
        }
    }

    openModalEliminar() {
        this.modalBaja = true;
    }

    closeModalEliminar() {
        this.modalBaja = false;
    }

    openModalCrear() {
        this.modalCrear = true;
        this.userModel = {
            userId: null,
            email: null,
            nombre: null,
            rutDv: null,
            rolId: '',
        };
    }

    closeModalCrear() {
        this.modalCrear = false;
        this.userModel = null;
    }

    openModalEditar(usuario: UserList) {
        let [userRol] = this.roles.filter((f) => f.name == usuario.ROL);

        this.userModel = {
            userId: usuario.IDENTIFICADOR,
            email: usuario.CORREO,
            nombre: usuario.NOMBRE,
            rutDv: usuario.RUTDV,
            rolId: userRol.id,
        };

        this.modalEditar = true;
    }

    closeModalEditar() {
        this.modalEditar = false;
        this.userModel = null;
    }

    guardarUser() {
        if (this.userModel) {
            this.guardandoUser = true;
            // if (!this.userModel.rolId) {
            //     console.log("No guardar si no tiene selecionado ningun rol");
            //     this.guardandoUser = false;
            //     return;
            // }
            this._administracion
                .creaActualizaUsuario(
                    this.userModel.userId,
                    this.userModel.email,
                    this.userModel.nombre,
                    this.userModel.rutDv.replace(/\./g, ''),
                    this.userModel.rolId
                )
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.listarUsuarios();
                        this.guardandoUser = false;
                        this.closeModalCrear();
                        this.closeModalEditar();
                        this.alert = {
                            type: 'success',
                            message: 'Operación realizada exitosamente',
                        };

                        this.showAlertCrear = true;
                    },
                    error: (err: any) => {
                        //console.log(err);
                        switch (err.status) {
                            case 400:
                                this.alert = {
                                    type: 'error',
                                    message: 'Rut Incorrecto',
                                };
                                break;
                            case 409:
                                this.alert = {
                                    type: 'error',
                                    message: 'Usuario ya existe en el sistema previamente. Comunícate con tu administrador.',
                                };
                                break;
                            default:
                                this.alert = {
                                    type: 'error',
                                    message: 'No se pudo completar la operación',
                                };
                                break;
                        }

                        this.showAlertCrear = true;
                        this.showAlertEditar = true;

                        // setTimeout(() => {

                        //     this.showAlertCrear = false;
                        //     this.showAlertEditar = false;
                        // }, 3000);
                        this.guardandoUser = false;
                    },
                    complete: () => {},
                });
        }
    }

    resetPasswordUser() {
        if (this.userModel) {
            this.guardandoUser = true;
            this._administracion
                .resetPasswordUsuario(this.userModel.userId, this.userModel.email)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.guardandoUser = false;
                        this.alert = {
                            type: 'success',
                            message: 'Operación realizada exitosamente',
                        };
                        // this.closeModalEditar();
                        this.showAlertEditar = true;
                    },
                    error: (e: any) => {
                        let {
                            error,//"PasswordStrengthError" | "PasswordHistoryError" | "OtherError";
                            message//string;
                        } = e.error;
                        switch (error) {
                            case "PasswordStrengthError":
                                this.alert = {
                                    type   : 'error',
                                    message: 'No se pudo asignar la contraseña. Intente nuevamente.'
                                    // message: 'Contraseña no cumple con formato de seguridad.'
                                };
                                break;
                            case "PasswordHistoryError":
                                this.alert = {
                                    type   : 'error',
                                    message: 'No se pudo asignar la contraseña. Intente nuevamente.'
                                    // message: 'No puedes utilizar una contraseña anterior.'
                                };
                                break;
                            default:
                                this.alert = {
                                    type   : 'error',
                                    message: 'No se pudo completar la operación.'
                                };
                                break;
                        }
                        this.showAlertEditar = true;

                        this.guardandoUser = false;
                    },
                    complete: () => {},
                });
        }
    }
}
